export default [
    {
        path: '/users',
        name: 'users',
        component: () =>
            import(/* webpackChunkName: "users" */ '@/views/users/Index.vue'),
        meta: {
            requiresAuth: true,
            breadcrumb: [
                { text: 'Usuários', to: { name: 'users' }, disable: true },
            ],
        },
    },
    {
        path: '/users/create',
        name: 'users/create',
        component: () =>
            import(/* webpackChunkName: "users" */ '@/views/users/Create.vue'),
        meta: {
            requiresAuth: true,
            breadcrumb: [
                { text: 'Usuários', to: { name: 'users' }, disable: false },
                {
                    text: 'Novo',
                    to: { name: 'users/create' },
                    disable: true,
                },
            ],
        },
    },
    {
        path: '/users/edit/:id',
        name: 'users/edit',
        component: () =>
            import(/* webpackChunkName: "users" */ '@/views/users/Edit.vue'),
        meta: {
            requiresAuth: true,
            breadcrumb: [
                { text: 'Usuários', to: { name: 'users' }, disable: false },
                {
                    text: 'Editar',
                    to: { name: 'users/edit' },
                    disable: true,
                },
            ],
        },
        props: true,
    },
]
